<template>
  <div class="page">
    <div v-if="isLoading" class="mb-2">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="text-center">
        載入中...
      </div>
    </div>
    <div v-else class="earn-count">
      <img src="./images/earn-count-bg.jpg" class="img-fluid" />

      <router-link class="earn-count__rules" :to="{ name: 'LiffProjAbbottAnd2026LotteryQ2Rules',query: $route.query }">
        <img src="./images/earn-count-btn-rules.png" class="rules-btn img-fluid" />
      </router-link>
      <span class="earn-count__count">{{ earnCount }}</span>

      <div class="earn-count__info">
          <a href="https://liff.line.me/1565710169-g0YZ75wA" target="_blank">
            <img src="./images/earn-count-btn-1.png" class="img-fluid" />
          </a>

          <router-link v-if="expired" :to="{ name: 'LiffProjAbbottAnd2026LotteryResult',query: { event_code: 'e2026Q1' } }">
            <img src="./images/earn-count-btn-3.png" class="img-fluid" />
          </router-link>
          <a v-else href="#">
            <img src="./images/earn-count-btn-2.png" class="img-fluid" />
          </a>
        
      </div>
    </div>
  </div>
</template>
<script>
import abbottAndMixin from "@/mixins/liff/proj/abbott-and";
import redeemApi from "@/apis/liff/v2/redeem";
import { isAfter } from "date-fns";

export default {
  mixins: [abbottAndMixin],
  components: {},
  async mounted() {
    await this.init();
  },
  data() {
    return {
      isLoading: true,
      earnCount: 0,
      event: {
        config: {},
      },
    };
  },
  computed: {
    expired() {
      return this.event.config?.show_result_enable  &&
      isAfter(new Date(), new Date(this.event.config?.show_result_after_at));
    }
  },
  methods: {
    async init() {
      console.log("[AND EarnCount] init() -> calling fetchEarnCount()");
      this.earnCount = await this.fetchEarnCount();
      console.log("[AND EarnCount] earnCount:", this.earnCount);


      const response = await redeemApi.getRedeemEvent({
        event_code: this.$route.query.event_code,
      });
      this.event = response.data.data.event;

      this.isLoading = false;
    },
    
  }
}
</script>

<style lang="scss" scoped>
.earn-count {

  position: relative;


  &__rules {
    position: absolute;
    bottom: 10%;
    right: 2%;
    width: 12%;
  }

  &__count {
    position: absolute;
    bottom: 20.8%;
    left: 50%;
    transform: translateX(-50%);
    font-size: clamp(16px, 8vw, 60px) !important;
    font-weight: bold !important;
  }

  &__info {
    position: absolute;
    bottom: 3%;
    left: 50%;
    transform: translateX(-50%);
    width: 60%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
  }
}
</style>
